import { HTTPClient } from './client/http-client.js';
import { ConfigurationsService } from './services/configurations-service.js';
import { IssuesService } from './services/issues-service.js';
import { OrganizationsService } from './services/organizations-service.js';
import { SystemService } from './services/system-service.js';

/**
 * Main API Client (Public Routes Only)
 * Orchestrates all service instances and provides unified access to public endpoints
 *
 * NOTE: This client is designed for public access only and does not include
 * authentication-required endpoints.
 */
export class APIClient {
  constructor(config = {}) {
    this.httpClient = new HTTPClient(config);

    // Initialize service instances
    this.issues = new IssuesService(this.httpClient);
    this.organizations = new OrganizationsService(this.httpClient);
    this.configurations = new ConfigurationsService(this.httpClient);
    this.system = new SystemService(this.httpClient); // Note: All system routes throw errors
  }

  /**
   * Get API root information (PUBLIC)
   */
  async getAPIInfo() {
    return this.httpClient.get('/');
  }

  /**
   * Test API connectivity (PUBLIC)
   */
  async testConnection() {
    try {
      const response = await this.getAPIInfo();
      return {
        connected: true,
        response
      };
    } catch (error) {
      return {
        connected: false,
        error: error.message
      };
    }
  }

  /**
   * Get all services for advanced usage
   */
  getServices() {
    return {
      issues: this.issues,
      organizations: this.organizations,
      configurations: this.configurations,
      system: this.system // Note: System service methods will throw errors
    };
  }

  /**
   * Get HTTP client instance for custom requests
   */
  getHttpClient() {
    return this.httpClient;
  }

  // NOTE: Authentication methods removed as this is a public-only client:
  // - setAuthToken() - not needed for public routes
  // - clearAuthToken() - not needed for public routes
  // - setHeader() - available through getHttpClient() if needed
  // - removeHeader() - available through getHttpClient() if needed
}